import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _Product } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { Modal } from "../../../../../../theme/Component/Modal";
import { CardTaps } from "../../../../../../theme/Component/CardTaps";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { toast } from "react-toastify";
import { SelectProductEditor } from "../../../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { _single } from "../../../../../../../core/services/dataBean/EntityCatalog";


interface Props {
    label?: string;
    idSelector: number;
    idProduct?: number;
    onChange?: any;
}

export const SelectUBLItemValue = ({ idSelector, label, onChange, idProduct }: Props) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_Product)
    const [productID, setProductID] = useState<number>(idProduct);
    const [responseValue, setResponseValue] = useState<any>();
    const [renderValue, setRenderValue] = useState<number>()
    const [modal, setModal] = useState<any>({ name: 'Lista de precios', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        setRenderValue(idSelector)
        setResponseValue(idSelector)
    }, [idSelector])

    const selectItem = () => {
        setModal({ ...modal, view: false })
        if (onChange) {
            if (indexTap === 0) {
                onChange(responseValue);
                setRenderValue(responseValue)
            } else if (indexTap === 1) {
                onChange(bean?.PriceValue ?? null);
                setRenderValue(bean?.PriceValue ?? null)
            }
        }
    };

    const [indexTap, setIndexTap] = useState(0);

    const taps = [
        { id: 0, name: 'Valor Manual', disable: false },
        { id: 1, name: 'Lista de Precios', disable: false }
    ];

    useEffect(() => {
        getLista(idProduct ?? productID)
    }, [indexTap, productID, idProduct])

    const getLista = (id: number) => {
        instance.getPriceListItemCatalogByProduct(id, null).then(
            (resp) => {
                setLista(resp)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDPriceListItem', visible: true },
        { title: 'Año Lista de Precios', property: 'PriceListYear', visible: true },
        { title: 'Código Lista de Precios', property: 'PriceListCode', visible: true },
        { title: 'Nombre Lista de Precios', property: 'PriceListName', visible: true },
        { title: 'Precio de Venta', property: 'PriceValue', visible: true },
    ]

    return (
        <>
            <label>{label ? label : 'Costo de Lista'}</label>
            <input
                type="text"
                className="form-control"
                aria-label="Recipient's username"
                aria-describedby="button-addon2"
                placeholder="Buscar..."
                value={`${_single.formatMoneyText(renderValue)}`}
                onClick={() => { setModal({ ...modal, "view": true }) }}
            />

            <Modal modal={modal} updateModal={setModal} eventModal={() => { selectItem() }}>
                <div className="row">
                    <div className="col-md-12">
                        <CardTaps index={indexTap} taps={taps} updateIndex={setIndexTap} >
                            {indexTap === 0 &&
                                <div className="row">
                                    <div className="col-md-12">
                                        <InputMoney _value={responseValue} onChange={(e) => { setResponseValue(e) }} />
                                    </div>
                                </div>
                            }
                            {indexTap === 1 &&
                                <div className="row">
                                    {!idProduct &&
                                        <div className="col-md-12">
                                            <SelectProductEditor onChange={(e) => { setProductID(e.IDProduct) }} />
                                        </div>
                                    }
                                    <div className="col-md-12">
                                        <BasicTable body={lista} head={head} rowSet={setBean} />
                                    </div>
                                </div>
                            }
                        </CardTaps>
                    </div>
                </div>
            </Modal>
        </>
    )
}